// extracted by mini-css-extract-plugin
export default {"modal":"LS-z","error":"MS-z","disabled":"NS-z","fields":"OS-z","errorMsg":"PS-z","footer":"QS-z","formContentWrapper":"RS-z","productImage":"SS-z","overlay":"TS-z"};